<div class="modal-header">
  <h4 class="modal-title"><i class="fas fa-cog"></i> {{ "TITLE.FONT-PROPERTIES" | translate }}</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-4">
      <label class="font-weight-bold mb-0">{{"LABEL.FONT-FAMILY" | translate }}</label>
      <select class="form-control width-th-4"
              [(ngModel)]="fontProperty.fontFamily">
        <option *ngFor="let font of fontTypes" [value]="font.value">{{font.view}}</option>
      </select>
    </div>
    <div class="col-md-4">
      <label class="font-weight-bold mb-0">{{"LABEL.FONT-SIZE" | translate }}</label>
      <select class="form-control" [(ngModel)]="fontProperty.fontSize">
        <option *ngFor="let fontsize of fontSizes" [ngValue]="fontsize.size + 'px'">{{fontsize.size}}</option>
      </select>
    </div>
    <div class="col-md-4">
      <label class="font-weight-bold mb-0">{{"LABEL.FONT-COLOR" | translate }}</label>
      <input style="color: rgba(0,0,0,1);"
             class="form-control w-100"
             [style.background]="fontProperty.color"
             [cpAlphaChannel]="'always'"
             [cpOutputFormat]="'rgba'"
             [cpPresetColors]="['#000', '#2889e9']"
             [cpAddColorButton]="true"
             [(colorPicker)]="fontProperty.color"
             (colorPickerChange)="colorPickerChange($event)"/>
    </div>
  </div>
  <div>
    <label class="font-weight-bold mb-0">{{"LABEL.DESCRIPTION" | translate }}</label>
    <textarea class="form-control" rows="auto"
              [(ngModel)]="fontProperty.content">
      </textarea>
  </div>
  <div class="row">
    <div class="col-md-4">
      <label class="font-weight-bold mb-0">{{"LABEL.BACKGROUND-COLOR" | translate }}</label>
      <input style="color: rgba(0,0,0,0);"
             class="form-control w-100"
             [style.background]="fontProperty.backgroundColor"
             [cpAlphaChannel]="'always'"
             [cpOutputFormat]="'rgba'"
             [cpPresetColors]="['#000', '#2889e9']"
             [cpAddColorButton]="true"
             [(colorPicker)]="fontProperty.backgroundColor"
             (colorPickerChange)="backgroundColorPickerChange($event)"/>
    </div>
    <div class="col-md-4">
      <label class="font-weight-bold mb-0">{{"LABEL.FONT-WEIGHT" | translate }}</label>
      <select class="form-control" [(ngModel)]="fontProperty.fontWeight">
        <option *ngFor="let fontWeight of fontWeights" [value]="fontWeight.value">{{fontWeight.view}}</option>
      </select>
    </div>
    <div class="col-md-4">
      <label class="font-weight-bold mb-0">{{"LABEL.TEXT-ALIGN" | translate }}</label>
      <select class="form-control" [(ngModel)]="fontProperty.textAlign">
        <option *ngFor="let align of alignTexts" [value]="align.value">{{align.view}}</option>
      </select>
    </div>
  </div>
  <div>
    <label class="font-weight-bold mb-0">{{"LABEL.TEXT-DECORATION" | translate }}</label>
    <select class="form-control" [(ngModel)]="fontProperty.textDecoration">
      <option value="" *ngFor="let decoration of fontDecorations"
              [value]="decoration.value">{{decoration.view}}</option>
    </select>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-success"
          (click)="accept()"><i class="fas fa-exchange-alt"></i> {{ "BUTTON.APPLY-CHANGE" | translate }}</button>
</div>
